module.exports = __webpack_public_path__ + "img/9788963860091.c91095d3.jpg";